import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { blogApi } from "./blogApi";

export const useBlogSettings = () => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.BLOG_SETTINGS(),
    queryFn: () => blogApi.fetchBlogSettings(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.BLOG_SETTINGS(),
    });
  };

  return {
    isLoading,
    isFetching,
    blogSettings: data?.data,
    invalidate,
  };
};
